import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import CompareBlock from './components/CompareBlock.jsx';
import uiLocale from '../../../utils/UILocale.js';
import initCompareSessionStorageProducts from './initCompareSessionStorageProducts';
import initCompareCheckboxes from './initCompareCheckboxes';


export default function initCompareBlock(mountEl) {
  const translations = {
    title: uiLocale.getString('component.comparepanel.title'),
    compareLabel: uiLocale.getString('component.comparepanel.compare_button'),
    removeLabel: uiLocale.getString('component.comparepanel.remove_button'),
    tooltipTranslation: uiLocale.getString('component.comparecheckbox.please_remove_product'),
    fromDateTranslation: uiLocale.getString('component.productlisting.fromDateLabel'),
    toDateTranslation: uiLocale.getString('component.productlisting.toLabel'),
    mainProductWasPriceTranslation:
      uiLocale.getString('component.productlisting.mainProductWasLabel'),
    mainProductCurrentPriceTranslation: uiLocale.getString('component.productlisting.nowLabel'),
    separateSellingPriceTranslation:
      uiLocale.getString('component.productlisting.separate_selling_price'),
    wasPriceTranslation: uiLocale.getString('component.productlisting.wasLabel'),
    savingsPriceTranslation: uiLocale.getString('component.productlisting.saveLabel'),
    inStorePriceTranslation: uiLocale.getString('component.productlisting.priceInstoreLabel'),
    emailMeBackFirstLineTranslation:
      uiLocale.getString('component.productlisting.noDeliveryLabel'),
    emailMeBackLinkTranslation: uiLocale.getString('component.productlisting.emailBackLabel')
  };

  ReactDOM.render(
    <Provider store={window.appState}>
      <CompareBlock translations={translations} />
    </Provider>, mountEl
  );

  initCompareSessionStorageProducts();
  initCompareCheckboxes();
}
